<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import {formatDate} from "../lib/lib";
    import R, {LOADER} from "../lib/requests";
    import app from '../stores/app';
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import A from "../lib/Router/A.svelte";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Pagination from "../components/Pagination.svelte";
    import ReservationEditModal from "./ReservationEditModal.svelte";

    let search = {
        limit: 50,
        offset: 0,
        date_from: '',
        date_to: '',
        agent_id: null,
        status: null,
        term: '',
        sort_field: 'date_at DESC',
        show_total: 1,
    }
    let totalReservations = 0;
    let page = 1;
    let reservations = null;
    let selectedId = 0;
    let editId = null;

    const pageHeaderControls = [
        // {id: 'create', name: 'CREATE AGENT', class: 'hidden-xs'},
        // {
        //     id: 'create',
        //     name: '',
        //     icon: 'plus-circle',
        //     class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        // },
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'NAME', sortable: true},
        {key: 'persons', title: 'PERSONS', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: 'date_at', title: 'DATE', sortable: true, sort_way: 'DESC', class: 'hidden-sm hidden-xs'},
        {key: 'agent_id', title: 'AGENT', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: 'created_at', title: 'CREATED', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: '', title: ''},
    ];

    const load = (loader = LOADER.POPUP) => {
        const onSuccess = result => {
            reservations = result.reservations;
            totalReservations = result.total;
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.reservation.index, search, onSuccess, onFailure, loader);
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = `${detail.key} ${detail.sort_way}`;
        load();
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
    }

    // const onCreate = () => {
    //     editId = 0;
    // }

    const onEdit = (agent) => {
        selectedId = agent.id;
        editId = agent.id;
    }

    const closeEdit = data => {
        if (data) {
            load();
        }
        editId = null;
    }

    const onDelete = group => {
        Alert.delete("Delete reservation", `This will permanently delete the reservation for ${group.persons} persons at ${formatDate(group.date_at, 'd-m-y')}.\nAre you sure?`,
            () => deleteReservation(group.id)
        );
    }

    const deleteReservation = (id) => {
        const onSuccess = result => {
            reservations = reservations.filter(x => x.id !== result);
            Notifier.showMessage("Reservation deleted");
        }

        const onFailure = err => {
        };

        R.handle(R.reservation.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    const clearSearch = () => {
        search.date_from = '';
        search.date_to = '';
        search.agent_id = null;
        search.status = null;
        search.term = '';
        page = 1;
        load();
    }

    load(LOADER.PAGE);
</script>

<PageHeader title="Reservations" controls={ pageHeaderControls } on:reload={ load }/>

<div class="panel panel-simple ps-2 pe-2 pb-2 mb-4">
    <div class="row row-condensed">
        <div class="column-condensed col-xl-2 col-lg-2 col-md-3 col-6 pt-2">
            <div class="form-item">
                <div class="form-item-info top">from</div>
                <input type="date" class="form-control" bind:value={ search.date_from } on:change={ onSearch }>
            </div>
        </div>
        <div class="column-condensed col-xl-2 col-lg-2 col-md-3 col-6 pt-2">
            <div class="form-item">
                <div class="form-item-info top">to</div>
                <input type="date" class="form-control" bind:value={ search.date_to } on:change={ onSearch }>
            </div>
        </div>
        <div class="column-condensed col-xl-2 col-lg-4 col-md-6 pt-2">
            <select class="form-select" bind:value="{ search.agent_id }" on:change={ onSearch }>
                <option value={null}>-- agent --</option>
                {#each $app.agents as agent}
                    <option value="{ agent.id }">{agent.name}</option>
                {/each}
            </select>
        </div>
        <div class="column-condensed col-xl-1 col-lg-4 col-md-4 pt-2">
            <select class="form-select" bind:value="{ search.status }" on:change={ onSearch }>
                <option value={null}>-- status --</option>
                <option value={1}>Active</option>
                <option value={2}>Canceled</option>
            </select>
        </div>
        <div class="column-condensed col-xl-3 col-lg-8 col-md-4 pt-2">
            <input type="text" class="form-control" bind:value="{ search.term }" on:change={ onSearch }
                   placeholder="name or phone">
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-2 col-6 pt-2">
            <button class="btn btn-default btn-block" on:click={ clearSearch }>CLEAR</button>
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-2 col-6 pt-2">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>SEARCH</button>
        </div>
    </div>
</div>

{#if totalReservations > 0}
    <div class="mb-4">
        Total reservations: <b>{totalReservations}</b>
    </div>
{/if}

{#if reservations}
    {#if reservations.length}
        <table class="table table-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each reservations as item}
                <tr class="row-hover" class:canceled={item.status != 1} class:row-selected="{ selectedId === item.id }">
                    <td>
                        <button class="btn-reset is-link text-start" class:not-active={item.status != 1}
                                class:fst-italic={!item.name}
                                on:click="{ () => onEdit(item) }">
                            {#if item.name}
                                {item.name}
                            {:else}
                                not provided
                            {/if}
                        </button>
                        <div class="text-gray hidden-xl hidden-lg hidden-md mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <A href="/app/calendar/{item.date_at}" class="text-gray is-link">
                                    {formatDate(item.date_at, 'd-m-y')}
                                </A>
                                <div>{item.persons} persons</div>
                            </div>
                            {#if item.agent}
                                <div class="agent-info text-gray mt-2">
                                    {item.agent.name}
                                </div>
                            {/if}
                        </div>
                    </td>
                    <td class="persons-column text-gray text-end hidden-sm hidden-xs">
                        {item.persons}
                    </td>
                    <td class="date-column text-gray hidden-sm hidden-xs">
                        <A href="/app/calendar/{item.date_at}"
                           class="text-gray is-link">{formatDate(item.date_at, 'd-m-y')}</A>
                    </td>
                    <td class="text-gray hidden-sm hidden-xs">
                        {#if item.agent}
                            {item.agent.name}
                        {/if}
                    </td>
                    <td class="date-column text-gray hidden-sm hidden-xs">
                        {formatDate(item.created_at, 'd-m-y')}
                    </td>
                    <td class="button-column" title="delete agent">
                        <button class="btn-reset btn-action p-2" on:click="{ () => onDelete(item) }">
                            <AppIcon icon="trash" size="16"/>
                        </button>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage={ search.limit } totalItems={ totalReservations } page={ page }
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel-simple panel-pad">
            No reservations found
        </div>
    {/if}
{/if}

{#if editId != null}
    <ReservationEditModal reservationId={editId} closeCallback={closeEdit}/>
{/if}

<style>
    .persons-column {
        width: 50px;
    }

    .canceled {
        background: rgba(255, 0, 0, 0.1);
    }

    .agent-info {
        border-top: 1px dotted var(--default-border-color);
        padding-top: 5px;
    }
</style>